import type { User } from '/types/user-type';

export type AccountChanges = {
  firstName?: string;
  lastName?: string;
  salutation?: string;
  profileImageUrl?: string;
};

/** Update payload with the loaded account values, so fields that did not change are not blanked. */
export const toAccountUpdate = (account: User, changes: AccountChanges) => ({
  itemId: account.itemId,
  userId: account.itemId,
  firstName: account.firstName ?? '',
  lastName: account.lastName ?? '',
  salutation: account.salutation ?? '',
  email: account.email,
  phoneNumber: account.phoneNumber,
  // Backend expects the country; send the existing one so it is not blanked.
  country: account.country ?? '',
  profileImageUrl: account.profileImageUrl ?? '',
  memberships: [...(account.memberships ?? [])],
  ...changes,
});
